/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Tag_Add_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Type and press Enter" |
*
* @param {Iconik_Metadata_Tag_Add_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_tag_add_placeholder = /** @type {((inputs?: Iconik_Metadata_Tag_Add_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Tag_Add_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Type and press Enter")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Type and press Enter")
	return /** @type {LocalizedString} */ ("Type and press Enter")
});